import { BlogContentContainer } from "../../molecules/BlogContentContainer";
import { BlogContentTile } from "./components/BlogContentTile";

const data = [
  {
    id: "1",
    title: "Big title",
    blogText: "Blog text bla bla bla",
    date: "2024-03-11",
    isShortText: true
  },
  {
    id: "2",
    title: "Big title",
    blogText: "Blog text bla bla bla",
    date: "2024-03-13"
  }
];
// const defaultModalData = { isModal: false, blogId: "" };

export const Blog = () => {
  // const [modal, setModal] = useState(defaultModalData);

  return (
    <div className="flex flex-col bg-black px-20 pb-20 pt-10 text-white">
      <div className="flex max-w-7xl flex-col">
        <h3 className="mx-auto pb-16 text-6xl">Blog</h3>
        {/* <BlogFilters /> */}
        <BlogContentContainer>
          {data.map(blogData => (
            <BlogContentTile key={blogData.id} data={blogData} />
          ))}
        </BlogContentContainer>
      </div>
    </div>
  );
};
